export default {
    title: `<i class="fa fa-lg fa-pencil-square"></i> 제목, 수평선(가로줄), 인용구`,
    datas: [
        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 제목(Headline)`
        },
        { type: "text",
            content: "제목과 관련된 문법은 줄의 맨 앞에 #기호를 사용하면 됩니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section02/exam01.md",
            content:
`# 제일 큰 제목

제일 큰 제목 밑에 일반 텍스트

## 그 다음 제목

그 다음으로 큰 제목 밑에 일반 텍스트

### 그 다다음 제목

3단계 제목 밑에 일반 텍스트`
        },
        { type: "text",
            content: "눈치가 빠를 분은 규칙을 금방 알수 있습니다. 줄의 맨 앞에 #의 갯수가 제목의 Level을 결정합니다. <br><br>"
        },
        { type: "quiz",
            content: "[Quiz] 몇 단계까지의 제목을 지원할까요? (실험해 보세요!)",
            questions: [
                "5단계 제목 까지 지원",
                "6단계 제목 까지 지원",
                "7단계 제목 까지 지원", 
            ],
            answers: [1],
        },
        { type: "text",
            content: "보통은 4단계 제목 이상으로 넘어가는 경우는 드물기 때문에 충분한 단계까지의 제목을 지원한다고 생각됩니다. "
                + "한가지 짚고 넘어갈 점은 Github에서는 1,2단계의 제목에는 제목 글자 밑에 수평선이 생기는 것을 볼 수 있습니다."
        },
        { type: "text",
            content: "깃허브에서는 1,2단계의 제목을 아래와 같은 방법으로도 사용할 수 있습니다. "
                + "<small>(<strike>하지만 개인적으로 #을 사용하는게 훨씬 편하더군요.</strike>)</small>"
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section02/exam02.md",
            content:
`제일 큰 제목
===

제일 큰 제목 밑에 일반 텍스트


그 다음 제목
---

그 다음으로 큰 제목 밑에 일반 텍스트`
        },
        { type: "text",
            content: "마크다운의 제목은 Html의 &lt;h1>~&lt;h6>태그에 대응됩니다. "
                + "또 Github에서는 제목으로 지정한 부분은 자동으로 html로 변환되면서 앵커(Anchor) 링크가 걸리게 됩니다."
        },




        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 수평선`
        },
        { type: "text",
            content: "제목에 수평선이 나온김에 수평선을 긋는 방법에 대해 알아보겠습니다. "
                + "수평선은 3가지 기호 <code>*(별표), -(대시), _(언더바)</code>를 3번이상 연속 입력하여 사용할 수 있습니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section02/exam03.md",
            content:
`블라블라

***

라블라블

---

블라블라

___

라블라블`
        },
        { type: "text",
            content: "3가지 기호에 따른 차이는 없이 모두 동일한 수평선이 생깁니다. 특이한 점으로는 반복되는 문자 사이에 공백이 들어가도 잘 동작한다는 점입니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section02/exam04.md",
            content:
`블라블라

* * * * *

라블라블

*       *          *   *          *

블라블라`
        },
        


        { type: "subtitle",
            content: `<i class="fa fa-asterisk"></i> 인용구(Blockquote) `
        },
        { type: "text",
            content: "인용구는 다른 문서에서 가져와 쓴 구문이나 구절을 사용할 때 사용하는 문법입니다. "
                + '<small style="color: gray;">(<strike>인용구는 가급적 목적에 맞게 쓰는 것이 좋지만 꼭 인용 문장에만 사용해야 하는 것은 아닙니다.</strike>)</small>'
                + "인용구는 문장의 맨 앞부분에 > 기호를 사용하여 만들 수 있습니다."
        },
        { type: "code2", code: "md", drag: true,
            content: `> 인용문장`
        },
        { type: "text",
            content: "Github에서 인용구는 맨앞에 세로줄을 그려주고 글씨를 회색으로 표시해 줍니다."
        },
        { type: "code", code: "plaintext",
            result: "https://github.com/denlyou/sblabs_markdown_codelab_examples/blob/master/section05/exam01.md",
            content:
`인용구를 중첩 사용해 보도록 하겠습니다.

> 인용 레벨1
>> 인용레벨2
>>> 인용레벨3`
        },
        { type: "text",
            content: "인용구는 특별히 어려운 것은 없으며 중첩으로 사용이 가능합니다."
        },




        { type: "subtitle",
            content: `<i class="fa fa-check-square"></i> Check it!`
        },
        { type: "oxquiz",
            content: "Github에서 마크다운 문법으로 제목을 사용하면 자동으로 링크가 생긴다.",
            hint: "앵커는 HTML 문서 내부의 위치로 이동할수 있도록 해주는 일종의 Hyperlink입니다.",
            ans: true,
        },
        { type: "oxquiz",
            content: "마크다운에서는 3가지 기호로 수평선을 만들수 있는데 기호마다 만들어지는 수평선 모양이 조금씩 차이가 난다.",
            ans: false,
        },
        { type: "oxquiz",
            content: "인용구 안에서 제목, 리스트 등의 다른 마크다운 문법을 사용할 수 있다.",
            hint: "Github나 StackEdit를 열어서 직접 한번 해봅시다 ^^;",
            ans: true,
        },
        

        { type: "next",
            content: "다음",
            url: "/sections/03"
        },
    ]
}